import React, { Component } from 'react';

import Can from '../../Can';
import { Error } from '../../shared/Error/Error';
import { LoadingIndicator } from '../../shared/LoadingIndicator/LoadingIndicator';
import MonitoredDocumentChangeList from './components/MonitoredDocumentChangeList.component.jsx';
import Pager from '../../shared/Pager/Pager';
import PropTypes from 'prop-types';

// COMPONENT
class MonitoredDocumentChangesBrowser extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { onInitialLoad } = this.props;

        onInitialLoad();
    }

    render() {
        const {
            fetched,
            fetching,
            failed,
            monitoredDocumentChanges,
            onPageClick,
            paging: { pages, pageNumber },
        } = this.props;

        if (fetching && !fetched) {
            return <LoadingIndicator busy={fetching} />;
        } else if (failed) {
            return <Error message="Failed to fetch monitored document records" />;
        } else {
            return (
                <div className="card bg-light mb-3">
                    <div className="card-body">
                        <div className="card-title">
                            <div className="d-flex justify-content-between">
                                <h6 className="card-title">Monitored Document Changes</h6>
                            </div>
                            <Can I="read" a="Document">
                                <MonitoredDocumentChangeList
                                    monitoredDocumentChanges={monitoredDocumentChanges}
                                />
                                <Pager
                                    pages={pages}
                                    pageNumber={pageNumber}
                                    onPageChange={onPageClick}
                                />
                            </Can>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

MonitoredDocumentChangesBrowser.propTypes = {
    onInitialLoad: PropTypes.func.isRequired,
    onPageClick: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    failed: PropTypes.bool,
    monitoredDocumentChanges: PropTypes.array,
    paging: PropTypes.shape({
        pages: PropTypes.number.isRequired,
        pageSize: PropTypes.number.isRequired,
        pageNumber: PropTypes.number.isRequired,
    }),
};

export default MonitoredDocumentChangesBrowser;
